export class DataModelPassword {
    password: string = "";
    confirmationPassword: string = "";
    id!: string;
}